import React from "react";
import { vendorEcosystem } from "../mock/mock";

const VendorTile = ({ name, alt }) => (
  <div
    role="img"
    aria-label={alt}
    title={alt}
    className="group inline-flex items-center justify-center h-14 min-w-[130px] px-5 border border-ink/12 rounded-sm bg-ivory-50 text-ink/70 hover:text-ink hover:border-bronze hover:bg-white transition-colors cursor-default"
  >
    <span className="font-serif-display text-[15px] leading-none tracking-[-0.005em] whitespace-nowrap">
      {name}
    </span>
  </div>
);

const VendorEcosystem = () => {
  return (
    <section id="ecosystem" className="py-24 lg:py-32 bg-ivory-100/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-bronze" />
              <span className="text-[11px] uppercase tracking-[0.3em] text-ink/60">
                Technology & Vendor Ecosystem
              </span>
            </div>
            <h2 className="font-serif-display text-4xl lg:text-5xl text-ink leading-[1.05] font-light">
              Platforms I've worked with, in depth.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-ink/65 leading-relaxed">
              Hands‑on experience across the technology stacks that power regional enterprises —
              from managed print and enterprise workflow to networking, cybersecurity and business
              continuity. Not partner badges — working knowledge, earned in real deployments.
            </p>
          </div>
        </div>

        <div className="space-y-12">
          {vendorEcosystem.map((row) => (
            <div key={row.id}>
              <div className="flex flex-col sm:flex-row sm:items-baseline sm:justify-between gap-3 mb-5">
                <h3 className="text-[11px] uppercase tracking-[0.28em] text-bronze font-medium">
                  {row.category}
                </h3>
                <p className="text-xs text-ink/55 max-w-md">{row.caption}</p>
              </div>
              <div className="flex flex-wrap gap-2.5">
                {row.vendors.map((v) => (
                  <VendorTile key={v.name} name={v.name} alt={v.alt} />
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="mt-16 text-[11px] uppercase tracking-[0.22em] text-ink/40 max-w-3xl leading-relaxed">
          Vendor names shown for descriptive purposes only. All trademarks and logos are the
          property of their respective owners. No formal partnership is implied.
        </p>
      </div>
    </section>
  );
};

export default VendorEcosystem;
